<template>
  <v-app id="inspire"> 
    <v-content>
       
      <v-container fluid fill-height>
        
        <router-view></router-view>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: null,
    }),

    props: {
      source: String
    }
  };
</script>


// WEBPACK FOOTER //
// src/layouts/loginLayout.vue